export const GET_LIST_JOB = 'GET_LIST_JOB';
export const GET_LIST_JOB_BY_NAME = 'GET_LIST_JOB_BY_NAME';
export const JOB_INFO = 'JOB_INFO';